<template>
  <div class="tw-text-neutral-900 tw-text-base tw-leading-snug">
    <slot />
  </div>
</template>
